import styled from 'styled-components'
import fonts from '../../theme/fonts'
import Colors from '../../theme/colors'
import Breakpoints from '../../theme/breakpoints'

const ToastStyles = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 508px;
  min-height: 168px;
  box-sizing: border-box;
  border-radius: 12px;
  padding: 25px 28px;
  font-family: ${fonts.fontFamilies.Inter};
  font-weight: ${fonts.fontWeights.small};
  font-size: ${fonts.fontSizes.p18};
  font-style: normal;
  line-height: 24px;

  @media (max-width: ${Breakpoints.tablet}) {
    width: 100%;
  }

  .left-bar {
    background-color: #9280db;
    position: absolute;
    height: calc(100% - 32px);
    width: 8px;

    left: -4px;
    top: 16px;
    border-radius: 4px;
  }

  .toast-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    svg {
      width: 20px;
      height: 20px;
      margin-right: 18px;
    }
  }

  .toast-body {
    margin: 10px 28px 0 38px;
  }

  &.info {
    background-color: ${Colors.Secondary.purple100};

    .left-bar {
      background-color: ${Colors.Secondary.purple500};
    }

    .toast-header {
      color: ${Colors.Secondary.purple500};
    }

    svg {
      path {
        fill: ${Colors.Secondary.purple500};
      }
    }
  }

  &.success {
    background-color: ${Colors.Action.SuccessGreenLight};

    .left-bar {
      background-color: ${Colors.Action.SuccessGreen};
    }

    .toast-header {
      color: ${Colors.Action.SuccessGreen};
    }

    svg {
      path {
        fill: ${Colors.Action.SuccessGreen};
      }
    }
  }

  &.error {
    background-color: ${Colors.Action.ErrorRedLight};

    .left-bar {
      background-color: ${Colors.Action.ErrorRed};
    }

    .toast-header {
      color: ${Colors.Action.ErrorRed};
    }

    svg {
      path {
        fill: ${Colors.Action.ErrorRed};
      }
    }
  }

  &.show {
    opacity: 1;
    pointer-events: all;
  }

  .close {
    position: absolute;
    right: 28px;
    top: 28px;
    border: none;
    outline: none;
    background: none;
    cursor: pointer;

    svg {
      path {
        fill: ${Colors.Primary.GreyDark} !important;
      }
    }
  }

  .action {
    position: absolute;
    right: 25px;
    bottom: 30px;
    padding: 0;

    text-decoration-line: underline;
    -webkit-text-decoration-line: underline;
    text-decoration-color: ${Colors.Primary.Black};
    -webkit-text-decoration-color: ${Colors.Primary.Black};
  }
`

export default ToastStyles
